import _castArray from 'lodash/castArray'
import apiService from 'frontcore/data/api-service/api-service'
import {
  _delete,
  _get,
  _patch,
  _post,
  getUrlQueryParameterFromObject,
} from './apiClient'

const URL_BASE_CORE_EVIDENCES = 'core-evidences'
const URL_BASE_MEDIA = '/media/'
const URL_BASE_DOCUMENT = '/documents/'

export function patchCoreEvidence (id, data) {
  const url = `${URL_BASE_CORE_EVIDENCES}/${id}/`
  return _patch(url, data)
}

export function patchCoreEvidences (data) {
  const url = `${URL_BASE_CORE_EVIDENCES}/`
  return _patch(url, data)
}

export function getMedia (mediaId) {
  const url = `${getMediaURL()}${mediaId}/`
  return _get(url)
}

export function getMediaURL () {
  return API_URL + URL_BASE_MEDIA
}

export function getDocumentsURL () {
  return API_URL + URL_BASE_DOCUMENT
}
/**
 * @param { string } url - URL string
 * @returns { Promise<Blob> }
 */
export async function getDocumentPDF (url) {
  const response = await apiService
    .buildRequest()
    .withResponseType('blob')
    .get(url)
  if (!(response.data instanceof Blob)) throw new Error('Response is not a valid blob')
  return response.data
}

export function deleteCoreEvidence (id) {
  const url = `${URL_BASE_CORE_EVIDENCES}/${id}/`
  return _delete(url)
}

export function createCoreEvidence (data) {
  const url = `${URL_BASE_CORE_EVIDENCES}/`
  return _post(url, data)
}

export function cloneEvidences (evidencesIds) {
  return _post(`${URL_BASE_CORE_EVIDENCES}/clone/`, _castArray(evidencesIds))
}

export function getMedias (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${getMediaURL()}?${queryParams}` : `${URL_BASE_MEDIA}`
  return _get(url)
}
